import { Button } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

interface TitleBarComponentProps {
  actionButton?: React.ReactNode;
  isBack?: boolean;
  title?: string;
  reload?: () => void;
}

const TitleBarComponent: React.FC<TitleBarComponentProps> = (
  props: TitleBarComponentProps
) => {
  const { actionButton, isBack, reload, title } = props;
  const navigate = useNavigate();
  return (
    <div className="flex justify-between items-center mb-3">
      <div className="flex items-center gap-2">
        {!!isBack && (
          <Button  size="large"
            onClick={() => navigate(-1)}
            icon={<i className="fa-solid fa-arrow-left"></i>}
          ></Button>
        )}

        <p className="text-[23px] font-bold">{title}</p>
      </div>
      <div className="flex items-center gap-2">
        {!!actionButton && <>{actionButton}</>}
        {!!reload && (
          <Button
            size="large"
            onClick={() => reload()}
            icon={<i className="fa-solid fa-rotate-left"></i>}
          ></Button>
        )}
      </div>
    </div>
  );
};

export default TitleBarComponent;
